import Vue from 'vue'
import VueRouter from 'vue-router'

const TheContainer = () => import('@/containers/TheContainer');

const Profile = () => import('@/views/users/Profile');
const Register = () => import('@/views/users/Register');
const ForgotePassword = () => import('@/views/users/ForgotePassword');

const Terms = () => import('@/views/users/Terms');
const Premium = () => import('@/views/users/Premium');

const Charges = () => import('@/views/charges/Charges');
const ChargeCreate = () => import('@/views/charges/Create');

const Vehicles = () => import('@/views/vehicles/Vehicles');
const VehicleCreate = () => import('@/views/vehicles/Create');

const Directories = () => import('@/views/directories/Directory');
const Empresas = () => import('@/views/empresas/Empresa');

const Requests = () => import('@/views/requests/Request');
const RequestCreate = () => import('@/views/requests/Create');

const Providers = () => import('@/views/providers/Provider');

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/register',
        name: 'Registrar',
        component: Register
    },
    {
        path: '/forgote-password',
        name: 'Contraseña',
        component: ForgotePassword
    },
    {
        path: '/',
        redirect: "/charges",
        component: TheContainer,
        children: [
            {
                path: 'charges',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Cargas',
                        component: Charges,
                    },
                    {
                        path: 'add',
                        meta: { requiresAuth: true },
                        name: 'Publicar Carga',
                        component: ChargeCreate
                    },
                    {
                        path: ':id/edit',
                        name: 'Editar Carga',
                        meta: { requiresAuth: true },
                        component: ChargeCreate
                    }
                ]
            },
            {
                path: 'vehicles',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Unidades disponibles',
                        component: Vehicles,
                    },
                    {
                        path: 'add',
                        name: 'Publicar Unidade disponible',
                        meta: { requiresAuth: true },
                        component: VehicleCreate
                    },
                    {
                        path: ':id/edit',
                        name: 'Editar Unidade disponible',
                        meta: { requiresAuth: true },
                        component: VehicleCreate
                    }
                ]
            },
            {
                path: 'directories',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'D N T',
                        component: Directories,
                    }
                ]
            },
            {
                path: 'empresas',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'DOL',
                        component: Empresas,
                    }
                ]
            },
            {
                path: 'requests',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Requests',
                        component: Requests,
                    },
                    {
                        path: 'add',
                        name: 'RequestCreate',
                        meta: { requiresAuth: true },
                        component: RequestCreate
                    },
                    {
                        path: ':id/edit',
                        name: 'RequestEdit',
                        meta: { requiresAuth: true },
                        component: RequestCreate
                    }
                ]
            },
            {
                path: 'providers',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Proveedores',
                        component: Providers,
                    }
                ]
            },
            {
                path: 'profile',
                meta: { requiresAuth: true },
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Perfil',
                        component: Profile,
                    }
                ]
            },
            {
                path: 'premium',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Hazte Premium',
                        component: Premium,
                    }
                ]
            },
            {
                path: 'terms',
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '',
                        name: 'Terminos y Condiciones',
                        component: Terms,
                    }
                ]
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        const token = localStorage.getItem('token', null);

        if (token) {
            next()
        } else {
            next({ name: 'Login' })
        }
    } else {
        next()
    }
});

export default router
